import React, { useContext, createContext } from "react";
import { useState } from "react";

const ThemeContext = createContext({});

export const ThemeProvider = ({ children }) => {
  const [editClicked, setEditClicked] = useState(false);

  const [color, setColor] = useState({ background: { h: 147, s: 18, l: 17 } });
  const [btncolor, setBtnColor] = useState({ background: "#d4d4" });
  const [lightness, setLightness] = useState(10);
  const [saturation, setSaturation] = useState(17);
  const [copied, setCopied] = useState(false);

  const value = {
    editClicked,
    setEditClicked,
    color,
    setColor,
    lightness,
    setLightness,
    btncolor,
    setBtnColor,
    saturation,
    setSaturation,
    copied,
    setCopied,
  };
  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
